import React from 'react';
import dayjs from 'dayjs';
import FlexBox from 'components/UI/Layout/FlexBox';
import { Color } from 'shared/src/modules/styles/colors';
import { MuiListItem, MuiButton, MuiTypography } from 'theme/material-ui';
import { FontSize } from 'modules/styles/variables';
import { LinkTo } from 'modules/types/common';
import { Link } from 'react-router-dom';
import { RowItem } from './styled';

interface TestResultsRowItemProps {
  key?: string;
  date?: Date | string;
  resultName?: string;
  providerName?: string;
  read?: boolean;
  to?: string | LinkTo;
  children?: React.ReactNode;
  testID?: string;
  onClick?: () => void;
}

const TestResultsRowItem = ({
  key,
  date = '',
  resultName,
  providerName,
  read,
  to,
  children,
  testID,
  onClick
}: TestResultsRowItemProps) => {
  const formatedDate = dayjs(date).format('DD MMM YYYY');
  return (
    <MuiListItem
      data-testid={testID}
      key={key}
      style={{
        padding: 0,
        borderWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: Color.grayHue7
      }}
    >
      <MuiButton
        component={Link}
        to={to}
        fullWidth
        style={{ justifyContent: 'flex-start', minHeight: 73, padding: 15 }}
        onClick={onClick}
      >
        <RowItem>
          {children || (
            <>
              <FlexBox alignItems="flex-start">
                <MuiTypography fontWeight="normal" fontSize={FontSize.small}>
                  {formatedDate}
                </MuiTypography>
              </FlexBox>
              <FlexBox alignItems="flex-start">
                <MuiTypography fontWeight="bold">{resultName}</MuiTypography>
                <MuiTypography fontWeight="normal">{providerName}</MuiTypography>
              </FlexBox>
            </>
          )}
        </RowItem>
      </MuiButton>
    </MuiListItem>
  );
};

export default TestResultsRowItem;
